import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
    },
    menuCards: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
      gap: theme.spacing(1),
    },
    searchField: {
      width: '100%',
    },
  }),
  { name: 'MenuContentDefault' }
);
